import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-archived",
  "use": "icon-archived-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 16 16\" id=\"icon-archived\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" opacity=\".01\" /><path fill=\"#0091FF\" fill-rule=\"evenodd\" d=\"m14 4.5-2-3H4l-2 3v10h12v-10m-2.536-2 1.333 2H3.201l1.334-2zM3 13.5v-8h10v8zM8.5 8V7h-4v1z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol